"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortIcon = void 0;
const react_1 = require("react");
const React = require("react");
const icon_1 = require("./icon");
class SortIcon extends react_1.Component {
    render() {
        const { fill = icon_1.ICON_COLORS.fill } = this.props;
        return (React.createElement("svg", { width: "24px", height: "24px", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("g", { stroke: "none", strokeWidth: "1", fill: fill, fillRule: "evenodd" },
                React.createElement("g", { fill: fill },
                    React.createElement("path", { d: "M4 4h4v4H4zM4 10h10v4H4zM4 16h16v4H4z" })))));
    }
}
exports.SortIcon = SortIcon;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/sort.tsx
// module id = 2166
// module chunks = 0 1 2